import React from 'react';
import './scss/App.scss';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CookiesProvider } from 'react-cookie';
import { initializeApp } from 'firebase/app';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import routes from './routing/routes';
import { ProgressProvider } from './context/Progress';
import { ApiProvider } from './context/Api';
import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';

function App() {
  const { i18n } = useTranslation();
  const config = {
    apiKey: import.meta.env.VITE_API_KEY,
    projectId: import.meta.env.VITE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_APP_ID,
    measurementId: import.meta.env.VITE_MEASUREMENT_ID
  };
  initializeApp(config);
  setUserProperties(getAnalytics(), { platform: 'web' });

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        networkMode: 'offlineFirst', // try to get from the cache first
        staleTime: 1000 * 60 * 60 * 24, // 1 day
      }
    }
  });

  const router = createBrowserRouter(routes);
  return (
    <CookiesProvider>
      <ApiProvider i18n={i18n}>
        <ProgressProvider>
          <QueryClientProvider client={queryClient}>
            <div className="App" data-version={import.meta.env.VITE_VERSION}>
              <RouterProvider router={router} />
            </div>
          </QueryClientProvider>
        </ProgressProvider>
      </ApiProvider>
    </CookiesProvider>
  );
}

var deferredPrompt;
window.addEventListener('beforeinstallprompt', function(e) {
  // Prevent Chrome 67 and earlier from automatically showing the prompt
  e.preventDefault();
  // Stash the event so it can be triggered later.
  deferredPrompt = e;

  console.log('beforeinstallprompt');

  showAddToHomeScreen();
});
function showAddToHomeScreen() {
  var a2hsCookie = getCookie('a2hs');
  var a2hsPrompt = document.querySelector('.ad2hs-prompt');
  if (!a2hsCookie && a2hsPrompt) {
    a2hsPrompt.style.display = 'flex';

    var a2hsAdd = document.querySelector('.ad2hs-prompt .add-prompt');
    a2hsAdd.addEventListener('click', addToHomeScreen);
    var a2hsDismiss = document.querySelector('.ad2hs-prompt .dismiss-prompt');
    a2hsDismiss.addEventListener('click', dismissPrompt);
  }
}
function addToHomeScreen() {
  var a2hsBtn = document.querySelector('.ad2hs-prompt'); // hide our user interface that shows our A2HS button
  a2hsBtn.style.display = 'flex'; // Show the prompt
  deferredPrompt.prompt(); // Wait for the user to respond to the prompt
  deferredPrompt.userChoice.then(function(choiceResult) {
    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the A2HS prompt');
    } else {
      console.log('User dismissed the A2HS prompt');
    }
    logEvent(getAnalytics(), 'app_install', {
      action: choiceResult.outcome || 'dismissed'
    });
    deferredPrompt = null;
  });
}
function dismissPrompt() {
  var a2hsBtn = document.querySelector('.ad2hs-prompt'); // hide our user interface that shows our A2HS button
  a2hsBtn.style.display = 'none'; // Show the prompt
  deferredPrompt = null;

  // set cookie so user isn't prompted again
  setCookie('a2hs', 'dismissed', 180);
}
function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}
function setCookie(name, value, days) {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
}

export default App;
